import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { siteConfig } from "@/mocks/site";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/90 backdrop-blur">
      <nav className="container-site flex h-16 items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-archive-2-line text-lg"></i>
          </span>
          <Link
            to="/"
            className="whitespace-nowrap font-heading text-lg font-bold text-foreground-900"
          >
            {siteConfig.name}
          </Link>
        </div>

        <div className="hidden items-center gap-1 md:flex">
          {siteConfig.nav.map((item) => (
            <NavLink
              key={item.key}
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-100 font-medium text-primary-800"
                    : "text-foreground-700 hover:bg-background-100 hover:text-primary-700"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <span className="chip">
            <i className="ri-refresh-line mr-1"></i>
            持续补全中
          </span>
        </div>

        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-700 md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="打开菜单"
        >
          <i className={`ri-${open ? "close-line" : "menu-3-line"} text-2xl`}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {siteConfig.nav.map((item) => (
              <NavLink
                key={item.key}
                to={item.path}
                end={item.path === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm ${
                    isActive
                      ? "bg-primary-100 font-medium text-primary-800"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}